<div class="mobile-menu d-md-none d-block mobile-cart">
  <ul>
    <li [class.active]="menu.active" *ngFor="let menu of menuItem">
      <a
        href="javascript:void(0)"
        [routerLink]="menu.path"
      >
        <!-- Ícone do carrinho -->
        <div *ngIf="menu.icon === 'ri-shopping-cart'" class="cart-icon-container">
          <i class="{{ menu.icon }}-line deactivated"></i>
          <i class="{{ menu.icon }} activated"></i>
          <span 
            class="cart-badge" 
            *ngIf="(totalItems$ | async) && (totalItems$ | async)! > 0">
            {{ totalItems$ | async }}
          </span>
        </div>

        <!-- Imagem do rhino para conta -->
        <div *ngIf="menu.icon === 'ri-account-circle'" class="account-icon-container">
          <img
            src="assets/images/rhino.webp"
            alt="{{ 'auto_account' | translate }}"
            class="account-icon"
            [class.activated]="menu.active"
            [class.deactivated]="!menu.active"
          />
        </div>

        <!-- Outros ícones normais -->
        <i
          *ngIf="menu.icon !== 'ri-shopping-cart' && menu.icon !== 'ri-account-circle'"
          class="{{ menu.icon }}-line deactivated"
        ></i>
        <i
          *ngIf="menu.icon !== 'ri-shopping-cart' && menu.icon !== 'ri-account-circle'"
          class="{{ menu.icon }} activated"
        ></i>
        <span>{{ menu.title | translate}}</span>
      </a>
    </li>
  </ul>
</div>
